<template src="./Mensajes.html"></template>

<script>
import EnvioMensajes from "./EnvioMensajes/EnvioMensajes";
import MessageHistory from "./MessageHistory/MessageHistory";
import MensajesUnidicado from "./MensajesUnificado/MensajesUnificado";
export default {
  data() {
    return {
      verOverlay: false,
      verEnvioMensajes: false,
      verHistorialMensajes: false,
      mensajesUnificados: false,
    };
  },
  methods: {
    EnvioMensajes() {
      this.verEnvioMensajes = true;
      this.verHistorialMensajes = false;
      this.mensajesUnificados = false;
    },
    historialMensajes() {
      this.mensajesUnificados = false;
      this.verEnvioMensajes = false;
      this.verHistorialMensajes = true;
    },
    EnvioMensajesUnificado() {
      this.mensajesUnificados = true;
      this.verEnvioMensajes = false;
      this.verHistorialMensajes = false;
    },
    limpiarData() {
      this.verEnvioMensajes = false;
      this.verHistorialMensajes = false;
    },
    cerrarOverlay() {
      this.verOverlay = false;
      this.limpiarData();
    },
  },
  components: {
    EnvioMensajes,
    MessageHistory,
    MensajesUnidicado,
  },
  props: {
    dataPacient: {
      type: Object,
      default: "",
    },
    infoPatient: {
      type: Array,
      default: []
    }
  },
};
</script>

<style lang="scss" scoped src="./Mensajes.scss">
</style>


// WEBPACK FOOTER //
// src/components/Mensajes/Mensajes.vue